"use strict";

module.exports.deepClone = function(object) {
  return JSON.parse(JSON.stringify(object));
};



// WEBPACK FOOTER //
// ./app/util/util.js